import { CategorizationMap } from "portal/utils/categoryCollection/category";
import { InfoTab } from "./InfoTab";
import { PredictionPoint } from "protos/veselka/prediction_point";
import { PredictionTab } from "./PredictionTab";
import { RadioChipOption } from "portal/components/RadioChips";
import { SvgIcon, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import ModelIcon from "portal/images/icons/model.svg?react";
import React, { FC, ReactNode, useMemo, useState } from "react";

enum Tabs {
  INFO = "info",
  PREDICTION = "prediction",
}

interface PredictionPointSidePaneProps {
  data: PredictionPoint;
  categorizationMap: CategorizationMap;
  categoryOptions: RadioChipOption[];
  categoryId?: string;
  onClassify?: (predictionPointId: string, categoryId: string) => void;
  isSessionStale: boolean;
}
export const PredictionPointSidePane: FC<PredictionPointSidePaneProps> = ({
  data,
  categorizationMap,
  categoryOptions,
  categoryId,
  onClassify,
  isSessionStale,
}) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(Tabs.INFO);

  const {
    categoryId: predictedCategoryId,
    matchingPredictionPointId,
    similarityScore,
  } = data;

  const predictedCategory = useMemo(
    () => categoryOptions.find((c) => c.id === predictedCategoryId),
    [categoryOptions, predictedCategoryId]
  );

  return (
    <TabContext value={tab}>
      <TabList
        onChange={(_, val: Tabs) => setTab(val)}
        className="mb-4"
        textColor="inherit"
      >
        <Tab
          value={Tabs.INFO}
          label={
            <TabTitle
              name={t("models.categoryCollectionProfiles.metadata.details")}
              icon={(className) => <InfoIcon className={className} />}
            />
          }
        />
        {predictedCategoryId && (
          <Tab
            value={Tabs.PREDICTION}
            label={
              <TabTitle
                name={t(
                  "models.categoryCollectionProfiles.metadata.prediction"
                )}
                icon={(className) => (
                  <SvgIcon className={className}>
                    <ModelIcon />
                  </SvgIcon>
                )}
              />
            }
          />
        )}
      </TabList>
      <TabPanel value={Tabs.INFO} classes={{ root: "p-0" }}>
        <InfoTab
          data={data}
          categoryOptions={categoryOptions}
          categoryId={categoryId}
          onClassify={onClassify}
        />
      </TabPanel>
      <TabPanel value={Tabs.PREDICTION} classes={{ root: "p-0" }}>
        {predictedCategory && (
          <PredictionTab
            category={predictedCategory}
            categorizationMap={categorizationMap}
            categoryOptions={categoryOptions}
            similarityScore={similarityScore}
            matchingPredictionPointId={matchingPredictionPointId}
            isStale={isSessionStale}
            onReclassify={onClassify}
          />
        )}
      </TabPanel>
    </TabContext>
  );
};

interface TabTitle {
  name: string;
  icon: (className: string) => ReactNode;
}
const TabTitle: FC<TabTitle> = ({ name, icon }) => (
  <div className="flex gap-1">
    {icon("text-base mr-1")}
    {name}
  </div>
);
